module.exports = __webpack_public_path__ + "static/About-Clientv2-6bfd910de2153d9e6dae7c05d5dabb96.jpg";